import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import App from './App';
import { store } from './store';

Sentry.init({dsn: process.env.REACT_APP_SentryDsn});

ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx